import React from "react";
import ModalScreen from "../common/ModalScreen";
import { Check } from "lucide-react";
import OfferProposal from "../../model/OfferProposal";

interface AcceptOfferConfirmationProps {
  openModal: boolean;
  onClose: () => void;
  onConfirm: () => void;
  offerProposal: OfferProposal;
}

const AcceptOfferConfirmation: React.FC<AcceptOfferConfirmationProps> = ({
  openModal,
  onClose,
  onConfirm,
  offerProposal,
}) => {
  const closeModal = () => {
    onClose();
  };

  const handleConfirm = () => {
    onConfirm();
    closeModal();
  };

  // Calculate totals
  const totalValue = offerProposal.compound?.price?.value || 0;
  const totalWithoutVat = offerProposal.compound?.price?.without_vat || 0;
  const clientName = offerProposal.client?.name || "Cliente não especificado";

  if (!openModal) return null;

  return (
    <ModalScreen
      title="Aceitar Proposta"
      onClose={closeModal}
      state="confirm"
      footer={
        <div className="flex justify-end gap-2 p-4">
          <button className="button is-white" onClick={closeModal}>
            Cancelar
          </button>
          <button className="button is-success" onClick={handleConfirm}>
            <span className="icon is-small">
              <Check className="inline mr-1" />
            </span>
            <span>Confirmar Aceitação</span>
          </button>
        </div>
      }
    >
      <div className="p-6">
        <div className="notification is-success is-light mb-6 flex items-start">
          <span className="icon has-text-success mr-3 mt-1">
            <i className="fas fa-check-circle"></i>
          </span>
          <div>
            <p className="font-bold text-gray-800">
              Confirmar aceitação da proposta?
            </p>
            <p className="text-sm mt-1 text-gray-600">
              Esta ação irá criar uma encomenda no sistema. Por favor, verifique
              os dados abaixo antes de confirmar.
            </p>
          </div>
        </div>

        <div className="box shadow-sm border border-gray-100 p-4">
          <h3 className="title is-6 mb-4 border-b pb-2 text-gray-700">
            Detalhes da Proposta
          </h3>

          <div className="field mb-3">
            <label className="label text-xs uppercase tracking-wide font-semibold text-gray-500 mb-1">
              Cliente
            </label>
            <div className="control">
              <span className="text-base text-gray-700 font-medium">
                {clientName}
              </span>
            </div>
          </div>

          <div className="field mb-3">
            <label className="label text-xs uppercase tracking-wide font-semibold text-gray-500 mb-1">
              Configuração
            </label>
            <div className="control">
              <span className="text-base text-gray-700 font-medium">
                {offerProposal.compound?.name || "N/A"}
              </span>
            </div>
          </div>

          <div className="columns is-mobile">
            <div className="column is-6">
              <div className="field">
                <label className="label text-xs uppercase tracking-wide font-semibold text-gray-500 mb-1">
                  Valor (s/ IVA)
                </label>
                <div className="control">
                  <span className="title is-5 text-blue-600 font-bold">
                    {totalWithoutVat.toFixed(2)} €
                  </span>
                </div>
              </div>
            </div>
            <div className="column is-6">
              <div className="field">
                <label className="label text-xs uppercase tracking-wide font-semibold text-gray-500 mb-1">
                  Valor (c/ IVA)
                </label>
                <div className="control">
                  <span className="title is-5 text-blue-800 font-bold">
                    {totalValue.toFixed(2)} €
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalScreen>
  );
};

export default AcceptOfferConfirmation;
